export function createClientEntityId(prefix) {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 14)}`;
}

export async function createFileImportId(projectId, file) {
  const signature = [
    String(projectId || ""),
    String(file?.name || ""),
    String(file?.size || 0),
    String(file?.lastModified || 0),
  ].join("|");

  if (typeof crypto !== "undefined" && crypto.subtle && typeof TextEncoder !== "undefined") {
    const digest = await crypto.subtle.digest(
      "SHA-256",
      new TextEncoder().encode(signature)
    );
    const hex = [...new Uint8Array(digest)]
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join("");
    return `pafta-import-${hex}`;
  }

  return createClientEntityId("pafta-import");
}
